import { createHook, createStore, createContainer } from '@atlassian/react-sweet-state';
import { DEFAULT_PAGE_SIZE } from '../../common/constants';
import actions from './actions';
import type { ScreensServiceState, ScreensServiceContainerProps } from './types';

export type ScreensServiceActions = typeof actions;

export const initialState: ScreensServiceState = {
	screens: {
		values: [],
		maxResults: 0,
		startAt: 0,
		total: 0,
		isLast: false,
		isLoading: false,
		isError: false,
		error: undefined,
	},
	filter: { pageNumber: 1, pageSize: DEFAULT_PAGE_SIZE },
};

const Store = createStore<ScreensServiceState, ScreensServiceActions>({
	name: 'jira-admin-screens',
	initialState,
	actions,
});
export const useScreensService = createHook(Store);
const ScreensServiceContainer = createContainer<
	ScreensServiceState,
	ScreensServiceActions,
	ScreensServiceContainerProps
>(Store);

export default ScreensServiceContainer;
